<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M27.8636 47H21.1367" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path
			d="M17.5195 36.2344L17.7664 40.7287C17.8646 42.5102 19.3485 43.907 21.1439 43.907H27.8539L27.8511 43.9098C29.6465 43.9098 31.1304 42.513 31.2286 40.7315L31.2651 40.0568C31.2931 39.5382 31.1136 39.0475 30.7545 38.6711C30.3955 38.2947 29.913 38.0884 29.3912 38.0884H21.5927"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path
			d="M20.6627 35.3524C21.9139 35.6479 23.2043 35.7984 24.5003 35.7984C33.5976 35.7984 41.0006 28.4408 41.0006 19.3992C41.0006 10.3576 33.5976 3 24.5003 3C15.403 3 8 10.3576 8 19.3992C8 25.4827 11.3606 31.0337 16.7691 33.8914"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path
			d="M31.5 9C33.6264 10.4442 35.287 12.446 36.2997 14.7852"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
		/>
		<path
			d="M23.6712 29.0822C23.6073 29.0822 23.5435 29.0736 23.4796 29.0563C23.1807 28.9726 22.9805 28.7073 22.9805 28.3987L22.9921 21.967L19.4024 21.4882C19.0542 21.4421 18.7553 21.2257 18.6015 20.9085C18.4506 20.5912 18.468 20.2249 18.6537 19.9279L24.5621 10.3265C24.7246 10.0611 25.0351 9.94286 25.334 10.0265C25.6329 10.1101 25.8331 10.3755 25.8331 10.6841L25.8215 17.1187L29.4112 17.5975C29.7595 17.6436 30.0584 17.8599 30.2122 18.1772C30.3631 18.4944 30.3427 18.8607 30.1599 19.1578L24.2516 28.7592C24.1239 28.9669 24.0627 29.0563 23.7799 29.0822H23.6712Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
